
import { Component, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'

@Observer
@Component({
  scrollToTop: true,
  components: {
    InfiniteLoading
  }
})
export default class PageView extends Vue {
  body = null
  get PageStore() {
    return this.$store.$my
  }
  get pagePagination() {
    return this.PageStore.MyBishan
  }
  biShanType(itemType) {
    let types = ['上课', '活动', '消耗', '系统']
    return types[itemType - 1]
  }

  created() {}
  mounted() {}
  beforeDestroy() {}
}
